export default __webpack_public_path__ + "static/melting-2883094d4fde14da2a89cd23258d78f7.png";